import React, { useState, useEffect, useRef } from 'react';
import { FaPlus, FaComments, FaArrowLeft, FaPaperPlane, FaPaperclip, FaTimes, FaFileAlt, FaDownload, FaBookmark, FaBullhorn, FaEdit, FaTrash, FaInfoCircle } from 'react-icons/fa';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import AuthStorage from '~/Utils/AuthStorage';
import * as api from '~/Services/Service';
import {
  ChatDropdownOverlay,
  ChatDropdownContainer,
  ChatHeader,
  ChatTab,
  TabBadge,
  ChatBody,
  NovoChatButton,
  ConversaItem,
  ConversaAvatar,
  ConversaInfo,
  ConversaNome,
  ConversaPreview,
  ConversaMeta,
  ConversaHora,
  ConversaBadge,
  EmptyState,
  ConversaNaoLidas,
  SubHeader,
  BtnVoltar,
  SubHeaderTitulo,
  DepartamentoItem,
  MensagensContainer,
  MensagemBolha,
  MensagemAutor,
  MensagemAutorFoto,
  MensagemAutorNome,
  MensagemTexto,
  MensagemHora,
  MensagemAnexoItem,
  ChatInputContainer,
  ChatInput,
  ChatInputBtn,
  TopicoCard,
  TopicoTitulo,
  TopicoTexto,
  SeguirParaChatContainer,
  SeguirParaChatBtn,
  MensagemAssuntoTag,
  ComunicadoEditadoLabel,
  ComunicadoAcoes,
  ComunicadoAcaoBtn,
  AbaTitulo,
  MensagemRodape,
  MensagemInfoIcon,
  ModalLeiturasOverlay,
  ModalLeiturasContainer,
  ModalLeiturasHeader,
  ModalLeiturasBody,
  ModalLeiturasItem,
} from './styles';

const ChatDepartamento = ({ show, onHide, onContagemAtualizada, signalRMensagem, signalRComunicado }) => {
  const [abaAtiva, setAbaAtiva] = useState('meus-chats');
  const [departamentoUsuario, setDepartamentoUsuario] = useState(null);
  const [meusChats, setMeusChats] = useState([]);
  const [chatsDepto, setChatsDepto] = useState([]);
  const [busy, setBusy] = useState(null);
  const [tela, setTela] = useState('lista');
  const [gruposDepartamento, setGruposDepartamento] = useState([]);
  const [filtroGrupo, setFiltroGrupo] = useState('');
  const [grupoSelecionado, setGrupoSelecionado] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  const [filtroDepartamento, setFiltroDepartamento] = useState('');
  const [conversaAberta, setConversaAberta] = useState(null);
  const [mensagens, setMensagens] = useState([]);
  const [textoInput, setTextoInput] = useState('');
  const [anexos, setAnexos] = useState([]);
  const [temMaisMensagens, setTemMaisMensagens] = useState(true);
  const [carregandoMais, setCarregandoMais] = useState(false);
  const [departamentoSelecionado, setDepartamentoSelecionado] = useState(null);
  const [assuntos, setAssuntos] = useState([]);
  const [assuntoSelecionado, setAssuntoSelecionado] = useState(null);
  const [assuntoPendente, setAssuntoPendente] = useState(null);
  const [topicos, setTopicos] = useState([]);
  const [comunicados, setComunicados] = useState([]);
  const [naoLidasComunicados, setNaoLidasComunicados] = useState(0);
  const [temMaisComunicados, setTemMaisComunicados] = useState(true);
  const [carregandoMaisCom, setCarregandoMaisCom] = useState(false);
  const [textoComunicado, setTextoComunicado] = useState('');
  const [anexosComunicado, setAnexosComunicado] = useState([]);
  const [editandoCodigo, setEditandoCodigo] = useState(null);
  const [textoEditando, setTextoEditando] = useState('');
  const [modalLeituras, setModalLeituras] = useState({ aberto: false, leituras: [], carregando: false });
  const containerRef = useRef(null);
  const mensagensRef = useRef(null);
  const comunicadosRef = useRef(null);
  const fileInputRef = useRef(null);
  const fileInputComRef = useRef(null);
  const usuarioLogado = AuthStorage.getUser();
  const history = useHistory();
  const isGrupoTI = AuthStorage.isGrupoTI();

  useEffect(() => {
    if (show) {
      carregarDados();
    } else {
      setTela('lista');
      setConversaAberta(null);
      setGrupoSelecionado(null);
      setDepartamentoSelecionado(null);
      setAssuntos([]);
      setAssuntoSelecionado(null);
      setAssuntoPendente(null);
      setTopicos([]);
      setEditandoCodigo(null);
    }
  }, [show]);

  useEffect(() => {
    if (mensagensRef.current) {
      mensagensRef.current.scrollTop = mensagensRef.current.scrollHeight;
    }
  }, [mensagens]);

  useEffect(() => {
    if (comunicadosRef.current) {
      comunicadosRef.current.scrollTop = comunicadosRef.current.scrollHeight;
    }
  }, [comunicados]);

  useEffect(() => {
    if (!signalRMensagem) return;
    if (tela === 'conversa' && conversaAberta) {
      api.buscarMensagensChat(conversaAberta.codigo).then(async novas => {
        if (novas && novas.length > 0) {
          setMensagens(prev => {
            const codigosExistentes = new Set(prev.map(m => m.codigo));
            const apenasNovas = novas.filter(m => !codigosExistentes.has(m.codigo));
            return apenasNovas.length > 0 ? [...prev, ...apenasNovas] : prev;
          });
        }
        await api.marcarChatComoLido(conversaAberta.codigo);
        atualizarContagem();
      });
    }
    if (tela === 'lista' && show) {
      carregarDados();
    }
  }, [signalRMensagem]);

  useEffect(() => {
    if (!signalRComunicado) return;
    if (abaAtiva === 'comunicados' && show) {
      carregarComunicados();
      api.marcarComunicadoLido().then(() => atualizarContagem());
    } else {
      carregarContagemComunicados();
    }
  }, [signalRComunicado]);

  const carregarDados = async () => {
    setBusy('carregando');
    try {
      const usuario = await api.buscarUsuarioLogado();
      setDepartamentoUsuario(usuario && usuario.departamento ? usuario.departamento.descricao : null);

      const [meus, depto, contagemCom] = await Promise.all([
        api.buscarMeusChats(),
        api.buscarChatsDepartamento(),
        api.contarNaoLidasComunicados(),
      ]);
      setMeusChats(meus || []);
      setChatsDepto(depto || []);
      setNaoLidasComunicados(contagemCom ? (contagemCom.total || 0) : 0);
    } catch (err) {
      console.error('Erro ao carregar chats:', err);
    } finally {
      setBusy(null);
    }
  };

  const carregarContagemComunicados = async () => {
    try {
      const result = await api.contarNaoLidasComunicados();
      setNaoLidasComunicados(result ? (result.total || 0) : 0);
    } catch (err) {}
  };

  const carregarComunicados = async () => {
    setBusy('comunicados');
    try {
      const lista = await api.buscarComunicados();
      setComunicados(lista || []);
      setTemMaisComunicados((lista || []).length >= 10);
    } catch (err) {
      console.error('Erro ao carregar comunicados:', err);
    } finally {
      setBusy(null);
    }
  };

  const carregarMaisComunicados = async () => {
    if (carregandoMaisCom || !temMaisComunicados || comunicados.length === 0) return;
    setCarregandoMaisCom(true);
    try {
      const primeiroCodigoAtual = comunicados[0].codigo;
      const anteriores = await api.buscarComunicados(primeiroCodigoAtual);
      if (!anteriores || anteriores.length === 0) {
        setTemMaisComunicados(false);
      } else {
        setTemMaisComunicados(anteriores.length >= 10);
        const scrollEl = comunicadosRef.current;
        const scrollAntes = scrollEl ? scrollEl.scrollHeight : 0;
        setComunicados(prev => [...anteriores, ...prev]);
        setTimeout(() => {
          if (scrollEl) scrollEl.scrollTop = scrollEl.scrollHeight - scrollAntes;
        }, 0);
      }
    } catch (err) {
      console.error('Erro ao carregar comunicados anteriores:', err);
    } finally {
      setCarregandoMaisCom(false);
    }
  };

  const handleScrollComunicados = e => {
    if (e.target.scrollTop === 0 && temMaisComunicados) {
      carregarMaisComunicados();
    }
  };

  const abrirAbaComunicados = async () => {
    setAbaAtiva('comunicados');
    await carregarComunicados();
    if (naoLidasComunicados > 0) {
      await api.marcarComunicadoLido();
      setNaoLidasComunicados(0);
      atualizarContagem();
    }
  };

  const publicarComunicado = async () => {
    if (!textoComunicado.trim() && anexosComunicado.length === 0) return;
    setBusy('publicando');
    try {
      if (anexosComunicado.length > 0) {
        const formData = new FormData();
        formData.append('texto', textoComunicado.trim());
        anexosComunicado.forEach(file => formData.append('arquivos', file));
        await api.publicarComunicadoAnexo(formData);
      } else {
        await api.publicarComunicado({ texto: textoComunicado.trim() });
      }
      setTextoComunicado('');
      setAnexosComunicado([]);
      await carregarComunicados();
    } catch (err) {
      toast.error('Erro ao publicar comunicado.');
    } finally {
      setBusy(null);
    }
  };

  const iniciarEdicao = (codigo, textoAtual) => {
    setEditandoCodigo(codigo);
    setTextoEditando(textoAtual || '');
  };

  const salvarEdicao = async () => {
    if (!textoEditando.trim()) return;
    setBusy('editando');
    try {
      await api.editarComunicado(editandoCodigo, { texto: textoEditando.trim() });
      setEditandoCodigo(null);
      setTextoEditando('');
      await carregarComunicados();
    } catch (err) {
      toast.error('Erro ao editar comunicado.');
    } finally {
      setBusy(null);
    }
  };

  const confirmarExclusao = async (codigo) => {
    if (!window.confirm('Tem certeza que deseja excluir este comunicado?')) return;
    setBusy('excluindo');
    try {
      await api.excluirComunicado(codigo);
      await carregarComunicados();
    } catch (err) {
      toast.error('Erro ao excluir comunicado.');
    } finally {
      setBusy(null);
    }
  };

  const handleKeyDownComunicado = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      publicarComunicado();
    }
  };

  const adicionarAnexosComunicado = e => {
    const novos = Array.from(e.target.files);
    setAnexosComunicado(prev => [...prev, ...novos]);
    e.target.value = '';
  };

  const removerAnexoComunicado = index => {
    setAnexosComunicado(prev => prev.filter((_, i) => i !== index));
  };

  const abrirNovoChatDepto = async () => {
    setBusy('grupos');
    try {
      const lista = await api.listarGruposDepartamento();
      setGruposDepartamento(lista || []);
      setFiltroGrupo('');
      setTela('selecionar-grupo');
    } catch (err) {
      console.error('Erro ao carregar grupos:', err);
    } finally {
      setBusy(null);
    }
  };

  const selecionarGrupo = async grupo => {
    setGrupoSelecionado(grupo);
    setBusy('departamentos');
    try {
      const lista = await api.listarDepartamentosPorGrupo(grupo.codigo);
      setDepartamentos(lista || []);
      setFiltroDepartamento('');
      setTela('selecionar-departamento');
    } catch (err) {
      console.error('Erro ao carregar departamentos:', err);
    } finally {
      setBusy(null);
    }
  };

  const selecionarDepartamento = async depto => {
    setDepartamentoSelecionado(depto);
    setBusy('assuntos');
    try {
      const lista = await api.buscarAssuntosFaq(depto.codigo);
      setAssuntos(lista || []);
      setTela('selecionar-assunto');
    } catch (err) {
      console.error('Erro ao carregar assuntos:', err);
      setAssuntos([]);
      setTela('selecionar-assunto');
    } finally {
      setBusy(null);
    }
  };

  const selecionarAssunto = async assunto => {
    setAssuntoSelecionado(assunto);
    setBusy('topicos');
    try {
      const lista = await api.buscarConteudosFaq({ codigoAssunto: assunto.codigo });
      setTopicos(lista || []);
      setTela('topicos');
    } catch (err) {
      console.error('Erro ao carregar tópicos:', err);
      setTopicos([]);
      setTela('topicos');
    } finally {
      setBusy(null);
    }
  };

  const iniciarChatComAssunto = async () => {
    setBusy('iniciando');
    try {
      const resultado = await api.iniciarConversa({
        codigo_departamento_destino: departamentoSelecionado.codigo,
        codigo_grupo_departamento: grupoSelecionado.codigo,
      });
      setAssuntoPendente(assuntoSelecionado);
      await carregarDados();
      abrirConversa({
        codigo: resultado.codigo,
        departamento_destino: departamentoSelecionado.descricao,
        nome_criador: usuarioLogado.nome,
      });
    } catch (err) {
      toast.error('Erro ao iniciar conversa.');
    } finally {
      setBusy(null);
    }
  };

  const iniciarChatOutros = async () => {
    setBusy('iniciando');
    try {
      const resultado = await api.iniciarConversa({
        codigo_departamento_destino: departamentoSelecionado.codigo,
        codigo_grupo_departamento: grupoSelecionado.codigo,
      });
      await carregarDados();
      abrirConversa({
        codigo: resultado.codigo,
        departamento_destino: departamentoSelecionado.descricao,
        nome_criador: usuarioLogado.nome,
        codigo_usuario_criador: usuarioLogado.usuario,
      });
    } catch (err) {
      toast.error('Erro ao iniciar conversa.');
    } finally {
      setBusy(null);
    }
  };

  const abrirTopicoFaq = topico => {
    onHide();
    history.push('/faq', { itemSelecionado: topico });
  };

  const atualizarContagem = async () => {
    try {
      const result = await api.contarNaoLidasChat();
      if (onContagemAtualizada) onContagemAtualizada(result.total || 0);
    } catch (err) {}
  };

  const abrirConversa = async conversa => {
    setConversaAberta(conversa);
    setTela('conversa');
    setMensagens([]);
    setTemMaisMensagens(true);
    setBusy('mensagens');
    try {
      const msgs = await api.buscarMensagensChat(conversa.codigo);
      setMensagens(msgs || []);
      setTemMaisMensagens((msgs || []).length >= 10);
      if (conversa.nao_lidas > 0) {
        await api.marcarChatComoLido(conversa.codigo);
        await carregarDados();
        atualizarContagem();
      }
    } catch (err) {
      console.error('Erro ao carregar mensagens:', err);
    } finally {
      setBusy(null);
    }
  };

  const carregarMaisMensagens = async () => {
    if (carregandoMais || !temMaisMensagens || !conversaAberta || mensagens.length === 0) return;
    setCarregandoMais(true);
    try {
      const primeiroCodigoAtual = mensagens[0].codigo;
      const anteriores = await api.buscarMensagensChat(conversaAberta.codigo, primeiroCodigoAtual);
      if (!anteriores || anteriores.length === 0) {
        setTemMaisMensagens(false);
      } else {
        setTemMaisMensagens(anteriores.length >= 10);
        const scrollEl = mensagensRef.current;
        const scrollAntes = scrollEl ? scrollEl.scrollHeight : 0;
        setMensagens(prev => [...anteriores, ...prev]);
        setTimeout(() => {
          if (scrollEl) scrollEl.scrollTop = scrollEl.scrollHeight - scrollAntes;
        }, 0);
      }
    } catch (err) {
      console.error('Erro ao carregar mensagens anteriores:', err);
    } finally {
      setCarregandoMais(false);
    }
  };

  const handleScrollMensagens = e => {
    if (e.target.scrollTop === 0 && temMaisMensagens) {
      carregarMaisMensagens();
    }
  };

  const enviarMensagem = async () => {
    if (!textoInput.trim() && anexos.length === 0) return;
    if (!conversaAberta) return;

    setBusy('enviando');
    try {
      const codigoAssunto = assuntoPendente ? assuntoPendente.codigo : null;

      if (anexos.length > 0) {
        const formData = new FormData();
        formData.append('codigo_conversa', conversaAberta.codigo);
        formData.append('texto', textoInput.trim());
        if (codigoAssunto) formData.append('codigo_faq_assunto', codigoAssunto);
        anexos.forEach(file => formData.append('arquivos', file));
        await api.enviarMensagemChatAnexo(formData);
      } else {
        const payload = {
          codigo_conversa: conversaAberta.codigo,
          texto: textoInput.trim(),
        };
        if (codigoAssunto) payload.codigo_faq_assunto = codigoAssunto;
        await api.enviarMensagemChat(payload);
      }
      setAssuntoPendente(null);
      setTextoInput('');
      setAnexos([]);
      const novas = await api.buscarMensagensChat(conversaAberta.codigo);
      setMensagens(prev => {
        const codigosExistentes = new Set(prev.map(m => m.codigo));
        const apenasNovas = (novas || []).filter(m => !codigosExistentes.has(m.codigo));
        return apenasNovas.length > 0 ? [...prev, ...apenasNovas] : prev;
      });
    } catch (err) {
      toast.error('Erro ao enviar mensagem.');
    } finally {
      setBusy(null);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      enviarMensagem();
    }
  };

  const adicionarAnexos = e => {
    const novos = Array.from(e.target.files);
    setAnexos(prev => [...prev, ...novos]);
    e.target.value = '';
  };

  const removerAnexo = index => {
    setAnexos(prev => prev.filter((_, i) => i !== index));
  };

  const voltarParaLista = () => {
    setTela('lista');
    setConversaAberta(null);
    setMensagens([]);
    setTextoInput('');
    setAnexos([]);
    setDepartamentoSelecionado(null);
    setAssuntos([]);
    setAssuntoSelecionado(null);
    setAssuntoPendente(null);
    setTopicos([]);
    carregarDados();
  };

  const abrirModalLeituras = async codigoMensagem => {
    setModalLeituras({ aberto: true, leituras: [], carregando: true });
    try {
      const leituras = await api.buscarLeiturasMensagem(conversaAberta.codigo, codigoMensagem);
      setModalLeituras({ aberto: true, leituras: leituras || [], carregando: false });
    } catch (err) {
      setModalLeituras({ aberto: true, leituras: [], carregando: false });
    }
  };

  const abrirModalLeiturasComunicado = async codigoComunicado => {
    setModalLeituras({ aberto: true, leituras: [], carregando: true });
    try {
      const leituras = await api.buscarLeiturasComunicado(codigoComunicado);
      setModalLeituras({ aberto: true, leituras: leituras || [], carregando: false });
    } catch (err) {
      setModalLeituras({ aberto: true, leituras: [], carregando: false });
    }
  };

  const fecharModalLeituras = () => {
    setModalLeituras({ aberto: false, leituras: [], carregando: false });
  };

  const tituloConversa = () => {
    if (!conversaAberta) return '';
    return conversaAberta.departamento_destino || conversaAberta.nome_criador || '';
  };

  const formatarData = data => {
    if (!data) return '';
    const m = moment(data);
    if (m.isSame(moment(), 'day')) return m.format('HH:mm');
    if (m.isSame(moment(), 'year')) return m.format('DD/MM');
    return m.format('DD/MM/YY');
  };

  const formatarHoraMensagem = data => {
    if (!data) return '';
    return moment(data).format('HH:mm');
  };

  const getIniciais = nome => {
    if (!nome) return '?';
    const partes = nome.trim().split(' ');
    if (partes.length === 1) return partes[0][0].toUpperCase();
    return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
  };

  const nomeAba = departamentoUsuario || 'Departamento';

  const prefixoPreview = (conversa, abaDepartamento) => {
    if (!conversa.ultima_mensagem_usuario) return null;
    if (conversa.ultima_mensagem_usuario === usuarioLogado.usuario) return 'Você';
    if (abaDepartamento && conversa.ultima_mensagem_usuario === conversa.codigo_usuario_criador) return null;
    return conversa.ultima_mensagem_nome_usuario;
  };

  const naoLidasMeus = meusChats.reduce(
    (total, c) => total + (c.nao_lidas || 0),
    0
  );
  const naoLidasDepto = chatsDepto.reduce(
    (total, c) => total + (c.nao_lidas || 0),
    0
  );

  if (!show) return null;

  return (
    <>
      <ChatDropdownOverlay onClick={onHide} />
      <ChatDropdownContainer ref={containerRef}>
        {tela === 'lista' && (
          <ChatHeader>
            <ChatTab
              active={abaAtiva === 'meus-chats'}
              onClick={() => { setAbaAtiva('meus-chats'); setTela('lista'); }}
            >
              Meus Chats
              {naoLidasMeus > 0 && <TabBadge>{naoLidasMeus}</TabBadge>}
            </ChatTab>
            <ChatTab
              active={abaAtiva === 'departamento'}
              onClick={() => { setAbaAtiva('departamento'); setTela('lista'); }}
            >
              Departamento
              {naoLidasDepto > 0 && <TabBadge>{naoLidasDepto}</TabBadge>}
            </ChatTab>
            <ChatTab
              active={abaAtiva === 'comunicados'}
              onClick={abrirAbaComunicados}
            >
              Comunicados
              {naoLidasComunicados > 0 && <TabBadge>{naoLidasComunicados}</TabBadge>}
            </ChatTab>
          </ChatHeader>
        )}

        {tela === 'selecionar-grupo' && (
          <>
            <SubHeader>
              <BtnVoltar onClick={() => setTela('lista')}>
                <FaArrowLeft size={14} />
              </BtnVoltar>
              <SubHeaderTitulo>Novo Chat</SubHeaderTitulo>
            </SubHeader>
            <div style={{ padding: '8px 12px 0' }}>
              <ChatInput
                placeholder="Pesquisar grupo..."
                value={filtroGrupo}
                onChange={e => setFiltroGrupo(e.target.value)}
                autoFocus
              />
            </div>
            <ChatBody>
              {gruposDepartamento
                .filter(g => g.descricao.toLowerCase().includes(filtroGrupo.toLowerCase()))
                .map(grupo => (
                  <DepartamentoItem
                    key={grupo.codigo}
                    onClick={() => selecionarGrupo(grupo)}
                  >
                    <ConversaAvatar>{getIniciais(grupo.descricao)}</ConversaAvatar>
                    {grupo.descricao}
                  </DepartamentoItem>
                ))}
            </ChatBody>
          </>
        )}

        {tela === 'selecionar-departamento' && (
          <>
            <SubHeader>
              <BtnVoltar onClick={() => {
                setTela('selecionar-grupo');
                setDepartamentos([]);
                setDepartamentoSelecionado(null);
              }}>
                <FaArrowLeft size={14} />
              </BtnVoltar>
              <SubHeaderTitulo>{grupoSelecionado ? grupoSelecionado.descricao : 'Departamento'}</SubHeaderTitulo>
            </SubHeader>
            <div style={{ padding: '8px 12px 0' }}>
              <ChatInput
                placeholder="Pesquisar departamento..."
                value={filtroDepartamento}
                onChange={e => setFiltroDepartamento(e.target.value)}
                autoFocus
              />
            </div>
            <ChatBody>
              {departamentos
                .filter(d => d.descricao.toLowerCase().includes(filtroDepartamento.toLowerCase()))
                .map(depto => (
                  <DepartamentoItem
                    key={depto.codigo}
                    onClick={() => selecionarDepartamento(depto)}
                  >
                    <ConversaAvatar>{getIniciais(depto.descricao)}</ConversaAvatar>
                    {depto.descricao}
                  </DepartamentoItem>
                ))}
            </ChatBody>
          </>
        )}

        {tela === 'selecionar-assunto' && (
          <>
            <SubHeader>
              <BtnVoltar onClick={() => {
                setTela('selecionar-departamento');
                setAssuntos([]);
                setDepartamentoSelecionado(null);
              }}>
                <FaArrowLeft size={14} />
              </BtnVoltar>
              <SubHeaderTitulo>{departamentoSelecionado && departamentoSelecionado.descricao}</SubHeaderTitulo>
            </SubHeader>
            <ChatBody>
              {assuntos.map(assunto => (
                <DepartamentoItem
                  key={assunto.codigo}
                  onClick={() => selecionarAssunto(assunto)}
                >
                  <ConversaAvatar>{getIniciais(assunto.nome)}</ConversaAvatar>
                  {assunto.nome}
                </DepartamentoItem>
              ))}
              <DepartamentoItem onClick={iniciarChatOutros}>
                <ConversaAvatar color="#8993a4">?</ConversaAvatar>
                Outros
              </DepartamentoItem>
            </ChatBody>
          </>
        )}

        {tela === 'topicos' && (
          <>
            <SubHeader>
              <BtnVoltar onClick={() => {
                setTela('selecionar-assunto');
                setAssuntoSelecionado(null);
                setTopicos([]);
              }}>
                <FaArrowLeft size={14} />
              </BtnVoltar>
              <SubHeaderTitulo>{assuntoSelecionado && assuntoSelecionado.nome}</SubHeaderTitulo>
            </SubHeader>
            <ChatBody>
              {topicos.length === 0 ? (
                <EmptyState>
                  <FaComments size={40} />
                  <span>Nenhum tópico cadastrado para este assunto.</span>
                </EmptyState>
              ) : (
                topicos.map(item => (
                  <TopicoCard
                    key={item.codigo}
                    onClick={() => abrirTopicoFaq(item)}
                  >
                    <TopicoTitulo>{item.titulo}</TopicoTitulo>
                    <TopicoTexto>{(item.texto || '').replace(/<br\s*\/?>/g, ' ')}</TopicoTexto>
                  </TopicoCard>
                ))
              )}
            </ChatBody>
            <SeguirParaChatContainer>
              <SeguirParaChatBtn onClick={iniciarChatComAssunto} disabled={busy === 'iniciando'}>
                Seguir para Chat
              </SeguirParaChatBtn>
            </SeguirParaChatContainer>
          </>
        )}

        {tela === 'conversa' && (
          <>
            <SubHeader>
              <BtnVoltar onClick={voltarParaLista}>
                <FaArrowLeft size={14} />
              </BtnVoltar>
              <SubHeaderTitulo>{tituloConversa()}</SubHeaderTitulo>
            </SubHeader>
            <MensagensContainer ref={mensagensRef} onScroll={handleScrollMensagens}>
              {mensagens.length === 0 ? (
                <EmptyState>
                  <FaComments size={40} />
                  <span>Nenhuma mensagem ainda</span>
                </EmptyState>
              ) : (
                mensagens.map(msg => {
                  const minha = msg.codigo_usuario === usuarioLogado.usuario;
                  return (
                    <MensagemBolha key={msg.codigo} minha={minha}>
                      {!minha && (
                        <MensagemAutor>
                          {msg.url_foto ? (
                            <MensagemAutorFoto src={msg.url_foto} alt={msg.nome_usuario} />
                          ) : (
                            <ConversaAvatar style={{ width: 20, height: 20, fontSize: '0.55rem' }}>
                              {getIniciais(msg.nome_usuario)}
                            </ConversaAvatar>
                          )}
                          <MensagemAutorNome>{msg.nome_usuario}</MensagemAutorNome>
                        </MensagemAutor>
                      )}
                      {msg.nome_assunto && (
                        <MensagemAssuntoTag>
                          <FaBookmark size={10} />
                          {msg.nome_assunto}
                        </MensagemAssuntoTag>
                      )}
                      {msg.texto && (
                        <MensagemTexto minha={minha}>{msg.texto}</MensagemTexto>
                      )}
                      {msg.anexos && msg.anexos.length > 0 && msg.anexos.map(anexo => (
                        <MensagemAnexoItem
                          key={anexo.codigo}
                          minha={minha}
                          onClick={() => api.downloadAnexoChat(anexo.codigo, anexo.nome_arquivo)}
                        >
                          <FaFileAlt size={12} style={{ flexShrink: 0 }} />
                          <span>{anexo.nome_arquivo}</span>
                          <FaDownload size={10} style={{ flexShrink: 0 }} />
                        </MensagemAnexoItem>
                      ))}
                      <MensagemRodape>
                        <MensagemHora>{formatarHoraMensagem(msg.data_envio)}</MensagemHora>
                        {minha && conversaAberta && conversaAberta.codigo_usuario_criador === usuarioLogado.usuario && (
                          <MensagemInfoIcon onClick={() => abrirModalLeituras(msg.codigo)} title="Ver quem leu">
                            <FaInfoCircle size={10} />
                          </MensagemInfoIcon>
                        )}
                      </MensagemRodape>
                    </MensagemBolha>
                  );
                })
              )}
            </MensagensContainer>
            {anexos.length > 0 && (
              <div style={{ padding: '4px 12px', display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {anexos.map((file, i) => (
                  <span
                    key={i}
                    style={{
                      background: '#f4f5f7',
                      borderRadius: 12,
                      padding: '2px 8px',
                      fontSize: '0.72rem',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 4,
                      maxWidth: 180,
                    }}
                  >
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {file.name}
                    </span>
                    <FaTimes size={10} style={{ cursor: 'pointer', flexShrink: 0 }} onClick={() => removerAnexo(i)} />
                  </span>
                ))}
              </div>
            )}
            <ChatInputContainer>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                multiple
                onChange={adicionarAnexos}
              />
              <ChatInputBtn
                type="button"
                onClick={() => fileInputRef.current.click()}
                style={{ background: 'transparent', color: '#8993a4' }}
                title="Anexar arquivos"
              >
                <FaPaperclip size={14} />
              </ChatInputBtn>
              <ChatInput
                placeholder="Digite uma mensagem..."
                value={textoInput}
                onChange={e => setTextoInput(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={busy === 'enviando'}
              />
              <ChatInputBtn
                onClick={enviarMensagem}
                disabled={busy === 'enviando' || (!textoInput.trim() && anexos.length === 0)}
              >
                <FaPaperPlane size={14} />
              </ChatInputBtn>
            </ChatInputContainer>
          </>
        )}

        {tela === 'lista' && abaAtiva !== 'comunicados' && (
          <ChatBody>
            {abaAtiva === 'meus-chats' && (
              <>
                <NovoChatButton
                  onClick={abrirNovoChatDepto}
                  disabled={!!busy}
                >
                  <FaPlus size={12} />
                  Novo chat
                </NovoChatButton>

                {meusChats.length === 0 ? (
                  <EmptyState>
                    <FaComments size={40} />
                    <span>Nenhuma conversa iniciada</span>
                  </EmptyState>
                ) : (
                  meusChats.map(conversa => (
                    <ConversaItem
                      key={conversa.codigo}
                      onClick={() => abrirConversa(conversa)}
                    >
                      <ConversaAvatar>
                        {getIniciais(conversa.departamento_destino)}
                      </ConversaAvatar>
                      <ConversaInfo>
                        <ConversaNome>
                          {conversa.grupo_departamento_destino
                            ? conversa.grupo_departamento_destino + ' › ' + conversa.departamento_destino
                            : conversa.departamento_destino}
                        </ConversaNome>
                        <ConversaPreview>
                          {conversa.ultima_mensagem && (
                            <>
                              {prefixoPreview(conversa, false) && (
                                <strong>{prefixoPreview(conversa, false)}: </strong>
                              )}
                              {conversa.ultima_mensagem}
                            </>
                          )}
                        </ConversaPreview>
                        {conversa.nao_lidas > 0 && (
                          <ConversaNaoLidas>
                            {conversa.nao_lidas} {conversa.nao_lidas > 1 ? 'novas mensagens' : 'nova mensagem'}
                          </ConversaNaoLidas>
                        )}
                      </ConversaInfo>
                      <ConversaMeta>
                        <ConversaHora>{formatarData(conversa.data_ultima_mensagem)}</ConversaHora>
                        {conversa.nao_lidas > 0 && (
                          <ConversaBadge>{conversa.nao_lidas}</ConversaBadge>
                        )}
                      </ConversaMeta>
                    </ConversaItem>
                  ))
                )}
              </>
            )}

            {abaAtiva === 'departamento' && (
              <>
                {nomeAba && <AbaTitulo>{nomeAba}</AbaTitulo>}
                {chatsDepto.length === 0 ? (
                  <EmptyState>
                    <FaComments size={40} />
                    <span>Nenhuma conversa recebida</span>
                  </EmptyState>
                ) : (
                  chatsDepto.map(conversa => (
                    <ConversaItem
                      key={conversa.codigo}
                      onClick={() => abrirConversa(conversa)}
                    >
                      <ConversaAvatar>
                        {getIniciais(conversa.nome_criador)}
                      </ConversaAvatar>
                      <ConversaInfo>
                        <ConversaNome>{conversa.nome_criador}</ConversaNome>
                        <ConversaPreview>
                          {conversa.ultima_mensagem && (
                            <>
                              {prefixoPreview(conversa, true) && (
                                <strong>{prefixoPreview(conversa, true)}: </strong>
                              )}
                              {conversa.ultima_mensagem}
                            </>
                          )}
                        </ConversaPreview>
                        {conversa.nao_lidas > 0 && (
                          <ConversaNaoLidas>
                            {conversa.nao_lidas} {conversa.nao_lidas > 1 ? 'novas mensagens' : 'nova mensagem'}
                          </ConversaNaoLidas>
                        )}
                      </ConversaInfo>
                      <ConversaMeta>
                        <ConversaHora>{formatarData(conversa.data_ultima_mensagem)}</ConversaHora>
                        {conversa.nao_lidas > 0 && (
                          <ConversaBadge>{conversa.nao_lidas}</ConversaBadge>
                        )}
                      </ConversaMeta>
                    </ConversaItem>
                  ))
                )}
              </>
            )}
          </ChatBody>
        )}

        {abaAtiva === 'comunicados' && tela === 'lista' && (
          <>
            <MensagensContainer ref={comunicadosRef} onScroll={handleScrollComunicados}>
              {comunicados.length === 0 ? (
                <EmptyState>
                  <FaBullhorn size={40} />
                  <span>Nenhum comunicado</span>
                </EmptyState>
              ) : (
                comunicados.map(com => {
                  const minha = com.codigo_usuario === usuarioLogado.usuario;
                  return (
                    <MensagemBolha key={com.codigo} minha={minha}>
                      {!minha && (
                        <MensagemAutor>
                          {com.url_foto ? (
                            <MensagemAutorFoto src={com.url_foto} alt={com.nome_usuario} />
                          ) : (
                            <ConversaAvatar style={{ width: 20, height: 20, fontSize: '0.55rem' }}>
                              {getIniciais(com.nome_usuario)}
                            </ConversaAvatar>
                          )}
                          <MensagemAutorNome>{com.nome_usuario}</MensagemAutorNome>
                        </MensagemAutor>
                      )}
                      {editandoCodigo === com.codigo ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
                          <ChatInput
                            as="textarea"
                            value={textoEditando}
                            onChange={e => setTextoEditando(e.target.value)}
                            style={{ minHeight: 40, maxHeight: 80, resize: 'none', borderRadius: 8 }}
                            autoFocus
                          />
                          <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end' }}>
                            <ComunicadoAcaoBtn onClick={() => setEditandoCodigo(null)}>Cancelar</ComunicadoAcaoBtn>
                            <ComunicadoAcaoBtn onClick={salvarEdicao} disabled={busy === 'editando'}>Salvar</ComunicadoAcaoBtn>
                          </div>
                        </div>
                      ) : (
                        <>
                          {com.texto && (
                            <MensagemTexto minha={minha}>{com.texto}</MensagemTexto>
                          )}
                        </>
                      )}
                      {com.anexos && com.anexos.length > 0 && com.anexos.map(anexo => (
                        <MensagemAnexoItem
                          key={anexo.codigo}
                          minha={minha}
                          onClick={() => api.downloadAnexoComunicado(anexo.codigo, anexo.nome_arquivo)}
                        >
                          <FaFileAlt size={12} style={{ flexShrink: 0 }} />
                          <span>{anexo.nome_arquivo}</span>
                          <FaDownload size={10} style={{ flexShrink: 0 }} />
                        </MensagemAnexoItem>
                      ))}
                      <MensagemRodape>
                        <MensagemHora>{formatarHoraMensagem(com.data_envio)}</MensagemHora>
                        {minha && isGrupoTI && (
                          <MensagemInfoIcon onClick={() => abrirModalLeiturasComunicado(com.codigo)} title="Ver quem leu">
                            <FaInfoCircle size={10} />
                          </MensagemInfoIcon>
                        )}
                      </MensagemRodape>
                      {com.editado_em && (
                        <ComunicadoEditadoLabel>
                          editado em {moment(com.editado_em).format('DD/MM HH:mm')}
                        </ComunicadoEditadoLabel>
                      )}
                      {minha && editandoCodigo !== com.codigo && (
                        <ComunicadoAcoes>
                          <ComunicadoAcaoBtn onClick={() => iniciarEdicao(com.codigo, com.texto)}>
                            <FaEdit size={10} /> Editar
                          </ComunicadoAcaoBtn>
                          <ComunicadoAcaoBtn danger onClick={() => confirmarExclusao(com.codigo)}>
                            <FaTrash size={10} /> Excluir
                          </ComunicadoAcaoBtn>
                        </ComunicadoAcoes>
                      )}
                    </MensagemBolha>
                  );
                })
              )}
            </MensagensContainer>
            {isGrupoTI && (
              <>
                {anexosComunicado.length > 0 && (
                  <div style={{ padding: '4px 12px', display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {anexosComunicado.map((file, i) => (
                      <span
                        key={i}
                        style={{
                          background: '#f4f5f7',
                          borderRadius: 12,
                          padding: '2px 8px',
                          fontSize: '0.72rem',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 4,
                          maxWidth: 180,
                        }}
                      >
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {file.name}
                        </span>
                        <FaTimes size={10} style={{ cursor: 'pointer', flexShrink: 0 }} onClick={() => removerAnexoComunicado(i)} />
                      </span>
                    ))}
                  </div>
                )}
                <ChatInputContainer>
                  <input
                    type="file"
                    ref={fileInputComRef}
                    style={{ display: 'none' }}
                    multiple
                    onChange={adicionarAnexosComunicado}
                  />
                  <ChatInputBtn
                    type="button"
                    onClick={() => fileInputComRef.current.click()}
                    style={{ background: 'transparent', color: '#8993a4' }}
                    title="Anexar arquivos"
                  >
                    <FaPaperclip size={14} />
                  </ChatInputBtn>
                  <ChatInput
                    placeholder="Publicar comunicado..."
                    value={textoComunicado}
                    onChange={e => setTextoComunicado(e.target.value)}
                    onKeyDown={handleKeyDownComunicado}
                    disabled={busy === 'publicando'}
                  />
                  <ChatInputBtn
                    onClick={publicarComunicado}
                    disabled={busy === 'publicando' || (!textoComunicado.trim() && anexosComunicado.length === 0)}
                  >
                    <FaPaperPlane size={14} />
                  </ChatInputBtn>
                </ChatInputContainer>
              </>
            )}
          </>
        )}
      </ChatDropdownContainer>

      {modalLeituras.aberto && (
        <ModalLeiturasOverlay onClick={fecharModalLeituras}>
          <ModalLeiturasContainer onClick={e => e.stopPropagation()}>
            <ModalLeiturasHeader>
              <span>Visualizações</span>
              <FaTimes size={12} style={{ cursor: 'pointer' }} onClick={fecharModalLeituras} />
            </ModalLeiturasHeader>
            <ModalLeiturasBody>
              {modalLeituras.carregando ? (
                <div style={{ textAlign: 'center', padding: '20px', color: '#8993a4', fontSize: '0.82rem' }}>
                  Carregando...
                </div>
              ) : modalLeituras.leituras.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px', color: '#8993a4', fontSize: '0.82rem' }}>
                  Esta mensagem ainda não foi lida por ninguém
                </div>
              ) : (
                modalLeituras.leituras.map((l, i) => (
                  <ModalLeiturasItem key={i}>
                    <span>{l.nome_exibicao}</span>
                    <span style={{ color: '#8993a4', fontSize: '0.72rem' }}>
                      {moment(l.data_leitura).format('DD/MM HH:mm')}
                    </span>
                  </ModalLeiturasItem>
                ))
              )}
            </ModalLeiturasBody>
          </ModalLeiturasContainer>
        </ModalLeiturasOverlay>
      )}
    </>
  );
};

export default ChatDepartamento;
